/**
 * DTO builder for the v2 KYC create/update flow.
 *
 * @deprecated Prefer `buildCreateKycParams` from `src/features/kyc/utils`
 * and the `useSubmitKyc` orchestration hook from `src/features/kyc/hooks` for new code.
 * Still used by the legacy Step 1 hook (`create-kyc-record.ts`) pending a full migration
 * to `src/features/kyc`.
 */

import {CreateKycBasicFormStepFormValues} from "../multi-step/basic-details/schema-validation";
import {
  CreateKycRecordApiPayloadV2,
  SocialLinksV2ApiKeys,
} from "../../../../react-query-hooks/kyc/types";
import {KycSocialMediaOptions} from "../multi-step/basic-details/form-fields/social-links";
import {parseFromBackend} from "../multi-step/basic-details/form-fields/date-of-birth";

const SOCIAL_LINKS_V2_KEY_MAP: Record<KycSocialMediaOptions, SocialLinksV2ApiKeys> = {
  Instagram: "instagram",
  LinkedIn: "linkedIn",
  Facebook: "facebook",
  "Twitter/X": "twitterX",
  YouTube: "youTube",
  TikTok: "tikTok",
  Snapchat: "snapchat",
  Twitch: "twitch",
  Kick: "kick",
  Pinterest: "pinterest",
  Threads: "threads",
};

function buildPhoneNumber(values: CreateKycBasicFormStepFormValues): string {
  if (!values.numberCode) return values.phoneNumber;
  const cleanedPhoneNumber = values.phoneNumber.replace(/^0+/, "");
  return `${values.numberCode}${cleanedPhoneNumber}`;
}

export function createKycRecordDtoV2(
  values: CreateKycBasicFormStepFormValues
): CreateKycRecordApiPayloadV2 {
  return {
    address: values.address,
    businessName: values.businessName ?? "",
    country: values.country,
    email: values.emailAddress,
    fullName: values.legalName,
    postalCode: values.postalCode,
    serviceDescription: values.businessDescription,
    socialLinks: values.socialLinks.reduce((acc, item) => {
      if (item.link?.trim()) {
        const v2Key = SOCIAL_LINKS_V2_KEY_MAP[item.name];
        if (v2Key) acc[v2Key] = item.link;
      }
      return acc;
    }, {} as CreateKycRecordApiPayloadV2["socialLinks"]),
    gender: values.gender,
    dateOfBirth:
      parseFromBackend(values.dateOfBirth)?.format("YYYY-MM-DD") ?? values.dateOfBirth,
    phoneNumber: buildPhoneNumber(values),
  };
}
